import { Outlet } from '@tanstack/react-router';
import { useIsMobile } from '@/modules/use-window-width';
import Header from './Header';
import Footer from './Footer';
import FooterMobile from './FooterMobile';
import CookieBanner from './CookieBanner';
import GDPRModal from './GDPRModal';
import AiWidget from './AiWidget';
import { useAiOpen } from '@/shared/utils/useAiOpen';
import OnboardingProvider from './Providers/OnboardingProvider';

export default function DefaultLayout() {
  const isMobile = useIsMobile();
  const ai = useAiOpen();
  return (
    <>
      <GDPRModal />
      <OnboardingProvider>
        <div className="relative box-border flex min-h-screen w-full flex-col bg-background-main">
          <Header />
          {/* The AI widget reads this subtree as the current page's
              context — chrome and the widget itself must stay outside. */}
          <div id="page-content" className="contents">
            <Outlet />
          </div>
          <div className="mt-auto">
            <Footer />
          </div>
          {isMobile && <FooterMobile aiOpen={ai.open} onAiToggle={ai.toggle} />}
          <CookieBanner />
          <AiWidget
            open={ai.open}
            scope={ai.scope}
            onToggle={ai.toggle}
            onClose={ai.close}
          />
        </div>
      </OnboardingProvider>
    </>
  );
}
